export enum ToastMessageTypes {
  error = 'error',
  info = 'info',
  warning = 'warning',
  success = 'success'
}
